import { ThreeDots } from "react-loader-spinner";
import "../../Pages/Admin/Style.css";
import "./add_packages.css";
// import React, { useState } from "react";
import React, { useState, useEffect } from "react";
import { TailSpin } from "react-loader-spinner";
import "../../Api/apiUrls.js";
import {
  API_URL,
  getWorkshopSlotById,
  addWorkshopSlot,
  getWorkshopSlotByWorkshopId,
  UpdateWorkshopSlot,
  deleteWorkshopSlotById,
} from "../../Api/apiUrls";

function Workshop_booking_slots({ onClose, id, dateTime }) {
  const [
    modalWorkshop_booking_slotsIsOpen,
    setWorkshop_booking_slotsModalIsOpen,
  ] = useState("");

  const [isAddingWorkshop_booking_slots, setIsAddingWorkshop_booking_slots] =
    useState(false);
  const [datetime, setDatetime] = useState("");
  const [isAddingBookingSlot, setIsAddingBookingSlot] = useState(false);
  const [showFields4, setShowFields4] = useState(false);
  const [showFields2, setShowFields2] = useState(false);
  const [bookingSlot, setBookingSlot] = useState([]);
  const [bookingDate, setBookingDate] = useState("");
  const [bookingStartTime, setBookingStartTime] = useState("00:00");
  const [bookingEndTime, setBookingEndTime] = useState("00:00");
  const [bookingPrice, setBookingPrice] = useState("");
  const [bookingCapacity, setBookingCapacity] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [showFields, setShowFields] = useState(false);
  const [bookingNewDate, setBookingNewDate] = useState("");
  const [bookingNewStartTime, setBookingNewStartTime] = useState("");
  const [bookingNewEndTime, setBookingNewEndTime] = useState("");
  const [bookingNewPrice, setBookingNewPrice] = useState("");
  const [bookingNewCapacity, setBookingNewCapacity] = useState("");
  const [isUpdatingSlot, setIsUpdatingSlot] = useState(false);
  const [id2, setId2] = useState("");

  const closeWorkshop_booking_slots = () => {
    setWorkshop_booking_slotsModalIsOpen(false);
  };
  const handleAddClick2 = (event) => {
    event.preventDefault();
    setBookingDate(getTodayDate());
    setBookingStartTime("00:00");
    setBookingEndTime("00:00");
    setBookingPrice("");
    setBookingCapacity("");
    setShowFields2(true);
  };
  const handleCancelClick4 = () => {
    setShowFields4(false);
  };
  function reloadPage() {
    window.location.reload();
  }
  const handleCancelClick2 = () => {
    setShowFields2(false);
  };
  const handleCancelClick = () => {
    setShowFields(false);
  };
  function reloadPage() {
    window.location.reload();
  }

  const handleClick = (e) => {
    if (e.currentTarget === e.target) {
      onClose();
      reloadPage();
    }
  };

  const formatStartDate = (startDate) => {
    const date = new Date(startDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [handleClick]);
  useEffect(() => {
    fetch(`${getWorkshopSlotByWorkshopId}${id}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const bookingSlot = data.data.WorkshopSlot;
        console.log(bookingSlot);
        setBookingSlot(bookingSlot);
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  // ------------------------add workshop slot ------------------------------------------------------------
  const convertTo12HourFormat = (time) => {
    const [hours, minutes] = time.split(":");
    const amPm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert hours to 12-hour format
    return `${formattedHours}:${minutes}`;
  };
  // const [bookingSlot, setBookingSlot] = useState([]);
  const handleAddBookingSlot = async (event) => {
    try {
      event.preventDefault();

      if (!bookingDate) {
        alert("Please fill in all fields");
        return;
      }

      setIsAddingBookingSlot(true);
      // const formattedStartTime = convertTo12HourFormat(bookingStartTime);
      // const formattedEndTime = convertTo12HourFormat(bookingEndTime);
      const formData = new FormData();
      formData.append("date", bookingDate);
      formData.append("startTime", bookingStartTime);
      formData.append("endTime", bookingEndTime);
      formData.append("price", bookingPrice);
      formData.append("temp_id", dateTime);
      formData.append("totalSeats", bookingCapacity);
      formData.append("availableSeats", bookingCapacity);
      formData.append("workshop", id);

      const addResponse = await fetch(`${addWorkshopSlot}`, {
        method: "POST",
        body: formData,
      });

      if (!addResponse.ok) {
        alert("Failed to add Slot");
        return;
      }
      const getResponse = await fetch(`${getWorkshopSlotByWorkshopId}${id}`);

      if (!getResponse.ok) {
        alert("Failed to fetch slots");
        return;
      }

      const getData = await getResponse.json();
      const bookingSlot = getData.data.WorkshopSlot || [];

      setBookingSlot(bookingSlot);
      setShowFields2(false);
      setBookingDate("");
      setBookingStartTime("");
      setBookingEndTime("");
      setBookingPrice("");
      setBookingCapacity("");
    } catch (error) {
      console.error("Error handling FAQ:", error);
    } finally {
      setIsAddingBookingSlot(false);
    }
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    const today = getTodayDate();
    setBookingDate(today);
  }, []);

  // ---------------------------------get workshop slot by id --------------------------------------------------------

  const handleClick4 = (id2) => {
    // event.preventDefault();

    fetch(`${getWorkshopSlotById}${id2}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const bookingEachSlot = data.data.WorkshopSlot;
        setBookingNewDate(bookingEachSlot.date);
        setBookingNewStartTime(bookingEachSlot.startTime);
        setBookingNewEndTime(bookingEachSlot.endTime);
        setBookingNewPrice(bookingEachSlot.price);
        setBookingNewCapacity(bookingEachSlot.totalSeats);
        setDatetime(bookingEachSlot.temp_id);
        setId2(bookingEachSlot.id);
        console.log(bookingEachSlot.id);
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => {
        setIsLoading(false);
      });

    setShowFields4(true);
  };

  // -------------------------update wokshop slot ----------------------------------------------------------------

  const handleUpdateWorkshop = async (id2) => {
    try {
      setIsUpdatingSlot(true);

      const formData = new FormData();
      formData.append("WorkshopSlot_id", id2);
      formData.append("temp_id", dateTime);
      formData.append("date", bookingNewDate);
      formData.append("startTime", bookingNewStartTime);
      formData.append("endTime", bookingNewEndTime);
      formData.append("price", bookingNewPrice);
      formData.append("totalSeats", bookingNewCapacity);

      const updateResponse = await fetch(`${UpdateWorkshopSlot}`, {
        method: "PUT",
        body: formData,
      });

      if (!updateResponse.ok) {
        alert("Failed to update slot");
        return;
      }

      // Trigger get API after update
      const getResponse = await fetch(`${getWorkshopSlotByWorkshopId}${id}`);

      if (!getResponse.ok) {
        alert("Failed to fetch slots");
        return;
      }

      const getData = await getResponse.json();
      const bookingSlot = getData.data.WorkshopSlot || [];

      setBookingSlot(bookingSlot);
      setShowFields4(false);
    } catch (error) {
      console.error("Error handling slots:", error);
    } finally {
      setIsUpdatingSlot(false);
    }
  };

  // ---------------------------delete workshop slot ------------------------------------

  const handleDeleteWorkshop = (id2) => {
    fetch(`${deleteWorkshopSlotById}${id2}`, {
      method: "DELETE",
      headers: {
        accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Check if the delete operation was successful
        if (data.success) {
          // Trigger the get API after successful deletion
          return fetch(`${getWorkshopSlotByWorkshopId}${id}`);
        } else {
          // Handle the error if the delete operation was not successful
          alert(data.message);
        }
      })
      .then((getResponse) => {
        // Check if the get API response is successful
        if (getResponse && getResponse.ok) {
          return getResponse.json();
        } else {
          throw new Error("Failed to fetch slot");
        }
      })
      .then((getData) => {
        const bookingSlot = getData.data.WorkshopSlot || [];
        setBookingSlot(bookingSlot);
      })
      .catch((error) => {
        console.error("Error handling slot:", error);
      });
  };

  const [expiryDate, setExpiryDate] = useState("");

  useEffect(() => {
    // Get expiry date from localStorage and convert to ISO format
    const expiry = localStorage.getItem("date_of_expiry"); // Format: DD-MM-YYYY
    if (expiry) {
      const [day, month, year] = expiry.split("-");
      const isoExpiryDate = `${year}-${month}-${day}`; // Convert to YYYY-MM-DD
      setExpiryDate(isoExpiryDate); // Set the expiry date in ISO format
    }
  }, []);

  return (
    <div>
      {modalWorkshop_booking_slotsIsOpen && (
        <Workshop_booking_slots onClose={closeWorkshop_booking_slots} />
      )}
      <div className="popup-background" onClick={handleClick}>
        <div className="popup">
          <div
            class="modal-content"
            style={{
              width: "100%",
              height: "80%",
              padding: "2%",
              backgroundColor: "#fff",
              borderRadius: "5px",
            }}
          >
            <div
              class="modal-header"
              style={{
                width: "100%",
                marginBottom: "3%",
                borderBottom: "solid 1px #7e7a7a8c",
              }}
            >
              <h5
                class="modal-title"
                id="modalAddTitle"
                style={{ marginBottom: "2%" }}
              >
                <b>Update Slot</b>
              </h5>

              <button
                type="button"
                onClick={() => {
                  onClose();
                  reloadPage();
                }}
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="form-group">
              <label class="small mb-1" for="inputFullName">
                Workshop Slots
              </label>
              <button
                style={{
                  marginLeft: "10px",
                  fontSize: "14px",
                  borderRadius: "4px",
                  backgroundColor: "#000",
                  color: "#fff",
                }}
                onClick={handleAddClick2}
              >
                + Add
              </button>
            </div>
            {showFields2 && (
              <>
                <div
                  class="col-md-12"
                  style={{ display: "flex", paddingLeft: "0px" }}
                >
                  <div
                    class="form-group col-md-6"
                    style={{ paddingLeft: "0px" }}
                  >
                    <label class="small mb-1" for="inputFullName">
                      Select Date<font color="red"></font>
                    </label>
                    <input
                      class="form-control"
                      id="inputFullName"
                      type="date"
                      value={bookingDate}
                      min={bookingDate}
                      max={expiryDate ? expiryDate : bookingDate}
                      onChange={(e) => setBookingDate(e.target.value)}
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="small mb-1" for="inputFullName">
                      Select Start time <font color="red"></font>
                    </label>
                    <input
                      class="form-control"
                      id="inputFullName"
                      type="time"
                      value={bookingStartTime}
                      onChange={(e) => setBookingStartTime(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  class="col-md-12"
                  style={{ display: "flex", paddingLeft: "0px" }}
                >
                  <div
                    class="form-group col-md-6"
                    style={{ paddingLeft: "0px" }}
                  >
                    <label class="small mb-1" for="inputFullName">
                      Select End Time<font color="red"></font>
                    </label>
                    <input
                      class="form-control"
                      id="inputFullName"
                      type="time"
                      value={bookingEndTime}
                      onChange={(e) => setBookingEndTime(e.target.value)}
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label class="small mb-1" for="inputFullName">
                      Enter Price <font color="red"></font>
                    </label>
                    <input
                      class="form-control"
                      id="inputFullName"
                      type="number"
                      value={bookingPrice}
                      onChange={(e) => setBookingPrice(e.target.value)}
                    />
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="small mb-1" for="inputFullName">
                    Enter Seating Capacity<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="number"
                    value={bookingCapacity}
                    onChange={(e) => setBookingCapacity(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", marginBottom: "20px" }}>
                  <button
                    type="button"
                    style={{
                      marginLeft: "10px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      backgroundColor: "#000",
                      color: "#fff",
                      border: "none",
                      padding: "5px 20px",
                    }}
                    onClick={handleAddBookingSlot}
                  >
                    Add
                  </button>
                  <button
                    type="button"
                    onClick={handleCancelClick2}
                    style={{
                      marginLeft: "10px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      backgroundColor: "lightgrey",
                      color: "#000",
                      border: "none",
                      padding: "5px 20px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </>
            )}

            <div
              className="table-responsive"
              style={{ overflowY: "scroll", padding: "2%" }}
            >
              {isLoading === true ? (
                <div style={{ marginTop: "50px", marginLeft: "50%" }}>
                  <TailSpin color="black" width={50} />
                </div>
              ) : bookingSlot.length > 0 ? (
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Sr.No</th>
                      <th scope="col"> Date</th>
                      <th scope="col">Start Time</th>
                      <th scope="col">End Time</th>
                      <th scope="col">Price</th>
                      <th scope="col">Seating Capacity</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody id="tableBody">
                    {bookingSlot.map((bookingSlot, index) => (
                      <tr key={bookingSlot.id}>
                        <th scope="row">{index + 1}</th>

                        <td>
                          <b>{formatStartDate(bookingSlot.date) || "---"}</b>
                        </td>
                        <td>
                          <b>{bookingSlot.startTime}</b>
                          <br />
                        </td>
                        <td>
                          <b>{bookingSlot.endTime}</b>
                          <br />
                        </td>
                        <td>
                          <b>{bookingSlot.price || "---"}</b>
                          <br />
                        </td>
                        <td>
                          <b>{bookingSlot.totalSeats || "---"}</b>
                          <br />
                        </td>

                        <td>
                          <div className="social-links mt-2">
                          {bookingSlot.bookedSeats === "0" && (
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => handleClick4(bookingSlot.id)}
                              >
                                <i className="bi bi-pencil"></i>
                              </a>
                            )}
                            &nbsp;
                            <a
                              onClick={() =>
                                handleDeleteWorkshop(bookingSlot.id)
                              }
                            >
                              <i className="fas fa-trash"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <h5 style={{ textAlign: "center" }}> No data available </h5>
              )}
            </div>
            {showFields4 && (
              <div>
                <>
                  <div>
                    <div
                      class="col-md-12"
                      style={{ display: "flex", paddingLeft: "0px" }}
                    >
                      <div
                        class="form-group col-md-6"
                        style={{ paddingLeft: "0px" }}
                      >
                        <label class="small mb-1" for="inputFullName">
                          Select Date<font color="red"></font>
                        </label>
                        <input
                          class="form-control"
                          id="inputFullName"
                          type="date"
                          // value={eachSlot.startDate}
                          min={bookingDate}
                          value={bookingNewDate}
                          max={expiryDate ? expiryDate : bookingDate}
                          onChange={(e) => setBookingNewDate(e.target.value)}
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="small mb-1" for="inputFullName">
                          Select Start time <font color="red"></font>
                        </label>
                        <input
                          class="form-control"
                          id="inputFullName"
                          type="time"
                          // value={eachSlot.startTime}
                          value={bookingNewStartTime}
                          onChange={(e) =>
                            setBookingNewStartTime(e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div
                      class="col-md-12"
                      style={{ display: "flex", paddingLeft: "0px" }}
                    >
                      <div
                        class="form-group col-md-6"
                        style={{ paddingLeft: "0px" }}
                      >
                        <label class="small mb-1" for="inputFullName">
                          Select End Time<font color="red"></font>
                        </label>
                        <input
                          class="form-control"
                          id="inputFullName"
                          type="time"
                          // value={eachSlot.endTime}
                          value={bookingNewEndTime}
                          onChange={(e) => setBookingNewEndTime(e.target.value)}
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="small mb-1" for="inputFullName">
                          Enter Price <font color="red"></font>
                        </label>
                        <input
                          class="form-control"
                          id="inputFullName"
                          type="number"
                          // value={eachSlot.price}
                          value={bookingNewPrice}
                          onChange={(e) => setBookingNewPrice(e.target.value)}
                        />
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label class="small mb-1" for="inputFullName">
                        Enter Seating Capacity<font color="red"></font>
                      </label>
                      <input
                        class="form-control"
                        id="inputFullName"
                        type="number"
                        // value={eachSlot.capacity}
                        value={bookingNewCapacity}
                        onChange={(e) => setBookingNewCapacity(e.target.value)}
                      />
                    </div>
                    <div style={{ display: "flex", marginBottom: "20px" }}>
                      <button
                        type="button"
                        style={{
                          marginLeft: "10px",
                          fontSize: "14px",
                          borderRadius: "4px",
                          backgroundColor: "#000",
                          color: "#fff",
                          border: "none",
                          padding: "5px 20px",
                        }}
                        // onClick={handleeUpdate}
                        onClick={() =>
                          handleUpdateWorkshop(
                            id2,
                            bookingNewDate,
                            bookingNewStartTime,
                            bookingNewEndTime,
                            bookingNewPrice,
                            bookingNewCapacity
                          )
                        }
                      >
                        Update
                      </button>
                      <button
                        type="button"
                        onClick={handleCancelClick4}
                        style={{
                          marginLeft: "10px",
                          fontSize: "14px",
                          borderRadius: "4px",
                          backgroundColor: "lightgrey",
                          color: "#000",
                          border: "none",
                          padding: "5px 20px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </>
              </div>
            )}

            <div
              class="modal-footer"
              style={{
                padding: "2%",
                marginTop: "3%",
                borderTop: "solid 1px #7e7a7a8c",
              }}
            >
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                onClick={() => {
                  onClose();
                  reloadPage();
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Workshop_booking_slots;
